import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ReloadsModelService} from '../../../Models/Warehouse/Reloads/reloads-model.service';
import {ReloadProductStoreForm} from '../../../../Models/Warehouse/Reloads/reload-product-store.model';

@Injectable({
  providedIn: 'root'
})
export class ReloadsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ReloadsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener recargas
   *
   */
  getReloads(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getRecargas', {}).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar una recarga de un producto
   *
   */
  public setReloadProduct(params: ReloadProductStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setConfigAlmacen', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
